export enum YesNo {
  YES = 'YES',
  NO = 'NO',
}

export const yesNoOptions = [
  {
    label: 'Yes',
    id: YesNo.YES,
  },
  {
    label: 'No',
    id: YesNo.NO,
  },
];

export enum YesNoNotAware {
  YES = 'YES',
  NO = 'NO',
  NOT_AWARE = 'NOT_AWARE',
}

export const yesNoNotAwareOptions = [
  {
    label: 'Yes',
    id: YesNoNotAware.YES,
  },
  {
    label: 'No',
    id: YesNoNotAware.NO,
  },
  {
    label: 'Not Aware',
    id: YesNoNotAware.NOT_AWARE,
  },
];

export enum PriceChanged {
  ONE_OFF = 'ONE_OFF',
  RECURRING = 'RECURRING',
}

export const priceChangedOptions = [
  {
    label: 'ONE_OFF',
    id: PriceChanged.ONE_OFF,
  },
  {
    label: 'RECURRING',
    id: PriceChanged.RECURRING,
  },
];

export enum DisputeAgreement {
  ACCEPT_INVOICE_AS_IS = 'ACCEPT_INVOICE_AS_IS',
  AMEND_INVOICE_CREDIT_NOTE = 'AMEND_INVOICE_CREDIT_NOTE',
  REJECT_INVOICE = 'REJECT_INVOICE',
  COMMERCIAL_SETTLEMENT_CREDIT_NOTE = 'COMMERCIAL_SETTLEMENT_CREDIT_NOTE',
  ACCEPT_INVOICE_WITH_CREDIT_NOTE = 'ACCEPT_INVOICE_WITH_CREDIT_NOTE',
  // New simplified options
  ACCEPT_INVOICE = 'ACCEPT_INVOICE',
  CANCEL_DISPUTE = 'CANCEL_DISPUTE',
}

export const disputeAgreementOptions = [
  {
    label: 'Accept invoice as-is (cleared)',
    id: DisputeAgreement.ACCEPT_INVOICE_AS_IS,
  },
  {
    label: 'Amend invoice (credit note)',
    id: DisputeAgreement.AMEND_INVOICE_CREDIT_NOTE,
  },
  {
    label: 'Reject invoice',
    id: DisputeAgreement.REJECT_INVOICE,
  },
  {
    label: 'Commercial settlement (credit note)',
    id: DisputeAgreement.COMMERCIAL_SETTLEMENT_CREDIT_NOTE,
  },
];

export const uctDisputeAgreementOptions = [
  {
    label: 'Accept invoice as-is (cleared)',
    id: DisputeAgreement.ACCEPT_INVOICE_AS_IS,
  },
  {
    label: 'Accept invoice with Credit Note',
    id: DisputeAgreement.ACCEPT_INVOICE_WITH_CREDIT_NOTE,
  },
  {
    label: 'Reject invoice',
    id: DisputeAgreement.REJECT_INVOICE,
  },
];

export const disputeResolutionOptions = [
  {
    label: 'Accept Invoice',
    description: 'With an expected Credit Note',
    id: DisputeAgreement.ACCEPT_INVOICE_WITH_CREDIT_NOTE,
    icon: '✓',
    color: 'green',
  },
  {
    label: 'Reject Invoice',
    description: 'Cancel the invoice',
    id: DisputeAgreement.REJECT_INVOICE,
    icon: '✕',
    color: 'red',
  },
  {
    label: 'Cancel Dispute',
    description: 'Go back to reviewing audit exceptions',
    id: DisputeAgreement.CANCEL_DISPUTE,
    icon: '↩',
    color: 'orange',
  },
];

export enum DisputeExpectedAmount {
  LUMP_SUM = 'LUMP_SUM',
  BREAK_DOWN_PER_DEVIATION = 'BREAK_DOWN_PER_DEVIATION',
}

export const disputeExpectedAmountOptions = [
  {
    label: 'Breakdown per deviation',
    id: DisputeExpectedAmount.BREAK_DOWN_PER_DEVIATION,
  },
  {
    label: 'Lump sum',
    id: DisputeExpectedAmount.LUMP_SUM,
  },
];

export const courierDisputeExpectedAmountOptions = [
  {
    label: 'Breakdown per deviation',
    id: DisputeExpectedAmount.BREAK_DOWN_PER_DEVIATION,
    disabled: true,
  },
  {
    label: 'Lump sum',
    id: DisputeExpectedAmount.LUMP_SUM,
    disabled: false,
  },
];
